import "./App.css";

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { useAuthStatus } from "./hooks/useAuthStatus";
import ErrorMessage from "./components/ErrorMessage";
import AuthWrapper from "./components/AuthWrapper";
import Header from "./components/Header";
import { Box, Container, createTheme, CssBaseline, Skeleton, ThemeProvider } from "@mui/material";

function App() {
  const { isGroupMember, apiToken, accessApi, authError } = useAuthStatus();

  const theme = createTheme({
    colorSchemes: {
      dark: true,
    },
  });

  return (
    <ThemeProvider theme={theme} defaultMode="system">
      <CssBaseline />
      <Box sx={{ height: "100vh", width: "100%" }}>
        <Header />
        <Container maxWidth="lg" >
          <AuthenticatedTemplate>
            {authError ?
              <ErrorMessage message={authError} />
              :
              <AuthWrapper
                isGroupMember={isGroupMember}
                apiToken={apiToken}
                accessApi={accessApi}
              />
            }
          </AuthenticatedTemplate>

          <UnauthenticatedTemplate>
            <Skeleton animation="wave" variant="rectangular" height={800} />
          </UnauthenticatedTemplate>
        </Container>
      </Box>
    </ThemeProvider>
  );
}

export default App;